import { render, staticRenderFns } from "./icon-arrow-long.vue?vue&type=template&id=5eb4d12e&scoped=true&"
import script from "./icon-arrow-long.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-long.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow-long.vue?vue&type=style&index=0&id=5eb4d12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb4d12e",
  null
  
)

export default component.exports